module.exports = __webpack_public_path__ + "img/icon-weixin.3bbb904e.png";